

































import { Component, Vue, Watch } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';

import { Organization } from '@/common/Organizations';

import TextField from '@/components/Form/TextField.vue';
import SwitchField from '@/components/Form/SwitchField.vue';

import { required, requiredIf } from 'vuelidate/lib/validators';

@Component({
	name: 'InvitesTab',
	components: {
		TextField,
		SwitchField,
	},
})
export default class OrgManagement extends Vue {
	@State('organization', { namespace: 'Organizations' }) private organization: Organization;
	private paginate: string[] = ['invites'];
	private invites: any[] = [];

	private fields: Organization = {
		org_id: '',
		org_name: '',
		is_agency: false,
		brokerageId: '',
		address: {
			address_line_1: '',
			address_line_2: '',
			city: '',
			state: '',
			zipcode: '',
		},
		phone_number: '',
		invites: [],
	};

	@Watch('organization', { deep: true} )
	private watchOrganization() {
		this.fields = this.organization;
		this.invites = this.organization.invites;
	}

	private loadInvite(email) {
		this.$router.push({
			name: 'staffusermanagementinvitesingle',
			params: {
				email,
			},
		});
	}

	private created() {
		this.fields = this.organization;
		this.invites = this.fields.invites;
	}
}
